import { getMiddlewareApi } from "@shared/externalApi";

export const markAsRead = async (id) => {
  const middlewareApi = await getMiddlewareApi();
  return middlewareApi.post("/blueroofApi/markAsRead", { id });
};

export const markAllAsRead = async (body) => {
  const middlewareApi = await getMiddlewareApi();
  return middlewareApi.post("/notifications/markAllAsRead", body);
};

export const searchActivities = async (body, signal) => {
  const middlewareApi = await getMiddlewareApi();
  return middlewareApi.post("/notifications/search", body, { signal });
};

export const getUnreadCategoryCountByUsers = async (body) => {
  const middlewareApi = await getMiddlewareApi();
  return middlewareApi.post("/notifications/getUnreadCountByType", body);
};
